module.exports = __webpack_public_path__ + "static/img/news8.18c9e60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/newscenter/news8.jpg
// module id = z4EW
// module chunks = 0